import { useState } from 'react';

import { IconAngleRight } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';
import { Calendar12MonthsSVG } from '@svgComponents/Calendar12MonthSVG';
import { FormattedMessage } from 'react-intl';

import DashboardCTA from '../../dashboardComponents/DashboardCTA/DashboardCTA';

export const RCFRenewal = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                closeIcon
            >
                <h3 className="my-0 text-2xl">
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_modal_title"
                        defaultMessage="Your repayment-free period"
                    />
                </h3>
                <p className="font-reg">
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_modal_description"
                        defaultMessage="We will contact you 30 days before the end of the repayment-free period to discuss your renewal options."
                    />
                </p>
                <p className="font-reg">
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_modal_description_2"
                        defaultMessage="The repayment-free period can be terminated by either party after 3 months. You will then repay the outstanding loan amount in 12 monthly instalments."
                    />
                </p>

                <Button onClick={() => setIsModalOpen(false)}>
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_modal_cta"
                        defaultMessage="Understood"
                    />
                </Button>
            </Modal>

            <DashboardCTA
                icon={<Calendar12MonthsSVG />}
                title={
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_action_title"
                        defaultMessage="You are within the repayment-free period"
                    />
                }
                description={
                    <FormattedMessage
                        id="_.outstanding_view.rcf_renewal_action_description"
                        defaultMessage="You’re only paying interest on the outstanding amount. Renewal possible after new credit checks."
                    />
                }
                cta={
                    <Button
                        variant="tertiary"
                        onClick={() => setIsModalOpen(true)}
                    >
                        <FormattedMessage
                            id="_.outstanding_view.rcf_renewal_action_cta"
                            defaultMessage="More information"
                        />{' '}
                        <IconAngleRight />
                    </Button>
                }
            />
        </>
    );
};
